import { memo } from 'react';

import { Modal } from '@/shared/components/Modal';
import { Grid, Text, Button } from '@develop-fapp/ui-kit-fapp';

import * as S from './styles';

interface DialogHasntNumberProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const Dialog: React.FC<DialogHasntNumberProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <S.Wrapper>
        <Text variant="h5" weight="bold">
          Sem número?
        </Text>
        <div>
          <Text variant="h8" weight="medium">
            Seu endereço está sem número.
          </Text>
          <Text variant="h8" weight="medium">
            Isso está correto?
          </Text>
        </div>
        <Grid xs="1fr 1fr" spacing="8px">
          <Button color="primary" variant="outlined" onClick={() => onClose()}>
            Cancelar
          </Button>
          <Button variant="contained" onClick={onConfirm}>
            Sim, sem número
          </Button>
        </Grid>
      </S.Wrapper>
    </Modal>
  );
};

export const DialogHasntNumber = memo(Dialog);
